import * as httpRequest from '../commons/httpRequest';

const EXTERNAL_IP_MIRRORS = ['https://api.ipify.org?format=json', 'https://ipinfo.io/json', 'https://api.my-ip.io/ip.json'];

/* Query 3rd party IP mirroring services like my-ip for the public IP address that they see for this machine
* This function will return the first successful response from the mirror. If all mirrors fail, it will return null;
*
* Note: In some clouds the machine might not have a sticky IP and then each request can potentially come out from a different IP.
* Note 2: It's possibble to add caching for this but it should be done after considering the implcations and probably behind an FF and possibly with a TTL.
*
* @returns {Promise<string | null>} - The public IP address
**/
export async function getPublicIp() {
    const result = await Promise.any(EXTERNAL_IP_MIRRORS.map(async (url) => {
        try {
            return await httpRequest.get(url);
        } catch (e) {
            return null;
        }
    }));
    return result?.ip;
}

export const generateWebSocketOptions = ({ timeout }: { timeout?: number }) => {
    return {
        timeout,
        ...(global.proxyUri && { agent: new global.ProxyAgent!(global.proxyUri) }),
    };
};
